import React, {useEffect, useState} from 'react'
import './Slider.css'
import dataSlider from './dataSlider'
import axios from 'axios';

export default function Slider() {
    const [slidePhoneImg, setSlidePhoneImg] = useState([])
    const [slidePcImg, setSlidePcImg] = useState([])
    const [slideIndex, setSlideIndex] = useState(1);
    
    useEffect(() => {
        const lastIndex = dataSlider.length
        
        if(slideIndex < 1){
            setSlideIndex(lastIndex)
        }

        if( slideIndex > lastIndex){
            setSlideIndex(1)
        }
    }, [slideIndex])

    useEffect(() => {
        let slider = setInterval(() => {
            setSlideIndex(slideIndex + 1)
        }, 5000);
        return () => clearInterval(slider)
    }, [slideIndex])

    const moveDot = index => {
        setSlideIndex(index)
    }

    var mediaQuery = window.matchMedia("(min-width: 520px)")

    useEffect(() => {
        axios
            .get('https://toycityzimbabwe.com/backend/getPcSlider.php')
            .then(res => {
                setSlidePcImg(res.data)
            })
            .catch( error => {
                console.log(error)
            });
      
    }, []);


    useEffect(() => {
        axios
        .get('https://toycityzimbabwe.com/backend/getPhoneSlider.php')
        .then(res => {
            setSlidePhoneImg(res.data)
        })
        .catch( error => {
            console.log(error)
        });
        
    }, [])

    return (
        <div className="container-slider">
            {(mediaQuery.matches) 
                ? 
                    (slidePcImg.map((obj, index) => (
                        <div
                        key={obj.id}
                        className={slideIndex === index + 1 ? "slide active-anim" : "slide"}
                        >
                            <img 
                                src={obj.img} 
                                alt='slidePcImg'
                            />
                        </div>
                    )) )
                
                :
                    (slidePhoneImg.map((obj, index) => (
                        <div
                        key={obj.id}
                        className={slideIndex === index + 1 ? "slide active-anim" : "slide"}
                        >
                            <img 
                                src={obj.img}
                                alt='slidePcImg'
                            />
                        </div>
                    ))  )
            }

            <div className="container-dots">
                {Array.from({length: 3}).map((item, index) => (
                    <div 
                        onClick={() => moveDot(index + 1)}
                        className={slideIndex === index + 1 ? "dot active" : "dot"}
                    ></div>
                ))}
            </div>
        </div>
    )
}